module.exports = __webpack_public_path__ + "media/recipes/85-a6bf7021.png";